import React from 'react';
import '../assets/css/Form.css';
import '../assets/css/Cogen.css';
import logo from '../assets/images/Logo.svg';
import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ReqPost } from '../config/Requests';

function Verification() {
	let navigate = useNavigate();
	const { token } = useParams();
	const values = {};
	values['email'] = atob(token);
	console.log(values);
	const handleEmail = e => {
		e.preventDefault();
		ReqPost('email-verification', values).then(() => {
			navigate(`/verify-email`);
		});
	};

	const handleMobile = e => {
		e.preventDefault();
		navigate(`/verify-mobile`);
	};

	return (
		<div className='main-container form-bg-color form-bg-log'>
			<img src={logo} className='form-logo' alt='logo' />
			<div className='form-container p-5'>
				<div className='form-label2-vmn mb-3'>Verification</div>
				<p className='mb-0 text-norm'>Welcome to COGEN.</p>
				<p className='mb-4 text-norm'>
					Please choose where you want to verify your account.
				</p>
				<Button
					type='submit'
					className='mb-2 btn-send-code'
					onClick={handleEmail}
				>
					VERIFY VIA EMAIL
				</Button>
				<Button
					type='submit'
					className='mb-4 btn-orange'
					onClick={handleMobile}
				>
					VERIFY VIA TEXT
				</Button>
			</div>
		</div>
	);
}

export default Verification;
